import { ScaleService } from './services/scale.service';
import { ClipboardService } from './services/clipboard.service';
import { SandboxMessengerService } from './services/sandbox-messenger.service';
import { QRCodeModule } from 'angularx-qrcode';
import { MediaService } from './model/api-services/media.service';
import { PDFOutputPreviewDialogService } from './components/dialogs/pdf-output-preview-dialog/pdf-output-preview-dialog-service';
import { PdfExportService } from './services/pdf-export.service';
import { SlColorsService } from './services/sl-colors.service';
import { ColorBrewerService } from './services/color-brewer.service';
import { GeomSymsService } from './services/geom-syms.service';
import { CriteriaService } from './services/criteria.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './login/login.component';
import { AppComponent } from './app.component';
import { APP_BASE_HREF } from '@angular/common';

import { ModalMessagerContentComponent } from './modal-messager/modal-messager.component';
import { CookieService } from 'ngx-cookie-service';
import { LogoutComponent } from './login/logout/logout.component';
import { FormAutoFillFixDirective } from './form-auto-fill-fix.directive';
import { InvalidBrowserComponent } from './invalid-browser/invalid-browser.component';
import {
  ModalLocationEntryContentComponent
} from './components/dialogs/modal-location-entry/modal-location-entry.component';

import { ModalLocationEntryService } from './components/dialogs/modal-location-entry/modal-location-entry.service';

import { GeocodeService } from './services/geocode.service';
import { FormsModule } from '@angular/forms';
import { DynamicComponentService } from './services/dynamic-component.service';
import { UiElementsModule } from './common-modules/ui-elements.module';
import { MappingModule } from './common-modules/mapping.module';
import { ModalResultStyleService } from './components/dialogs/modal-result-style/modal-result-style.service';
import { ModalResultStyleEntryComponent, ModalResultStyleComponent } from './components/dialogs/modal-result-style/modal-result-style.component';
import { LayerSelectionDialogComponent, LayerSelectionDialogEntryComponent } from './components/dialogs/layer-selection-dialog/layer-selection-dialog.component';
import { LayerSelectionDialogService } from './components/dialogs/layer-selection-dialog/layer-selection-dialog.service.';
import { LayerViewsService } from './model/api-services/layer-views.service';
import { ModalLayerSelectionComponent } from './components/dialogs/layer-selection-dialog/modal-layer-selection/modal-layer-selection.component';
import { environment } from 'src/environments/environment';
import { LabelStyleDialogComponent, LabelStyleEntryComponent } from './components/dialogs/label-style-dialog/label-style-dialog.component';
import { LabelStyleDialogService } from './components/dialogs/label-style-dialog/label-style-dialog.service.';
import { ColorGenDialogComponent, ColorGenDialogEntryComponent } from './components/dialogs/color-gen-dialog/color-gen-dialog.component';
import { ColorGenDialogService } from './components/dialogs/color-gen-dialog/color-gen-dialog.service';
import { ResultsPopupEditorDialogComponent, ResultsPopupEditorDialogEntryComponent } from './components/dialogs/results-popup-editor-dialog/results-popup-editor-dialog.component';
import { ResultsPopupEditorDialogService } from './components/dialogs/results-popup-editor-dialog/results-popup-editor-dialog-service';
import { SaveMapDialogComponent, SaveMapDialogEntryComponent } from './components/dialogs/save-map-dialog/save-map-dialog.component';
import { SaveMapDialogService } from './components/dialogs/save-map-dialog/save-map-dialog-service.';
import { LoadMapDialogComponent, LoadMapDialogEntryComponent } from './components/dialogs/load-map-dialog/load-map-dialog.component';
import { LoadMapDialogService } from './components/dialogs/load-map-dialog/load-map-dialog-service';
import {
  SaveLayerDialogComponent,
  SaveLayerDialogEntryComponent
} from './components/dialogs/save-layer-dialog/save-layer-dialog.component';
import { SaveLayerDialogService } from './components/dialogs/save-layer-dialog/save-layer-dialog-service';
import {
  LoadLayerDialogComponent,
  LoadLayerDialogEntryComponent
} from './components/dialogs/load-layer-dialog/load-layer-dialog.component';
import { LoadLayerDialogService } from './components/dialogs/load-layer-dialog/load-layer-dialog-service';
import { ColorPickerDialogEntryComponent, ColorPickerDialogComponent } from './components/dialogs/color-picker-dialog/color-picker-dialog.component';
import { ColorPickerDialogService } from './components/dialogs/color-picker-dialog/color-picker-dialog.service';
import { MapSelectorComponent } from './components/map-selector/map-selector.component';
import {
  MapPickerDialogComponent,
  MapPickerDialogEntryComponent
} from './components/dialogs/map-picker-dialog/map-picker-dialog.component';
import { LayerPickerDialogComponent, LayerPickerDialogEntryComponent } from './components/dialogs/layer-picker-dialog/layer-picker-dialog.component';
import { LayerPickerDialogService } from './components/dialogs/layer-picker-dialog/layer-picker-dialog.service';
import { MapPickerDialogService } from './components/dialogs/map-picker-dialog/map-picker-dialog-service';
import { ColorPaletteComponent } from './components/color-palette/color-palette.component';
import { ResultsService } from './services/results.service';
import { TimeoutInterceptor, DEFAULT_TIMEOUT } from './model/api-services/sl-wapi.service';
import { DragulaModule } from 'ng2-dragula';
import { AdddAttributeDialogService } from './components/dialogs/add-attribute-dialog/addd-attribute-dialog.service';
import { LightboxModule } from 'ngx-lightbox';
import { KmlExportService } from './services/kml-export-service';
import { ShpExportService } from './services/shp-export-service';
import { ExportDataDialogComponent, ExportDataDialogEntryComponent } from './components/dialogs/export-data-dialog/export-data-dialog.component';
import { ExportDataDialogService } from './components/dialogs/export-data-dialog/export-data-dialog-service.';
import { ProjectionService } from './model/api-services/projection.service';
import { ExcelIoService } from './services/io/excel-io.service';
import { DmiPagesModule } from './mapps/dmi-pages/dmi-pages.module';
import { DmiModule } from './mapps/dmi/dmi.module';
import { ActionHandlerService } from './services/action-handler.service';
import { ButtonGroupService } from './services/button-group.service';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { ScaleAndLocationDialogService } from './components/dialogs/scale-and-location-dialog/scale-and-location-dialog-service';
import { CustomSymbolDialogService } from './components/dialogs/custom-symbol-dialog/custom-symbol-dialog.service';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ModalMessagerContentComponent,
    ModalLocationEntryContentComponent,
    ModalResultStyleComponent,
    ModalLayerSelectionComponent,
    LogoutComponent,
    FormAutoFillFixDirective,
    InvalidBrowserComponent,
    LayerSelectionDialogComponent,
    LayerSelectionDialogEntryComponent,
    LabelStyleDialogComponent,
    LabelStyleEntryComponent,
    ColorGenDialogComponent,
    ColorGenDialogEntryComponent,
    ResultsPopupEditorDialogComponent,
    ResultsPopupEditorDialogEntryComponent,
    SaveMapDialogComponent,
    SaveMapDialogEntryComponent,
    LoadMapDialogComponent,
    LoadMapDialogEntryComponent,
    ExportDataDialogComponent,
    ExportDataDialogEntryComponent,
    SaveLayerDialogComponent,
    SaveLayerDialogEntryComponent,
    LoadLayerDialogComponent,
    LoadLayerDialogEntryComponent,
    ColorPickerDialogComponent,
    ColorPickerDialogEntryComponent,
    MapSelectorComponent,
    MapPickerDialogComponent,
    LayerPickerDialogComponent,
    MapPickerDialogEntryComponent,
    LayerPickerDialogEntryComponent,
    ColorPaletteComponent

  ],
  exports: [
  ],
  imports: [
    BrowserModule,
    QRCodeModule,
    FormsModule,
    AngularSlickgridModule,
    HttpClientModule,
    AppRoutingModule,
    UiElementsModule,
    DmiPagesModule,
    DmiModule,
    MappingModule,
    LightboxModule,
    DragulaModule.forRoot()
  ],
  providers: [
    // tslint:disable-next-line: no-string-literal
    { provide: APP_BASE_HREF, useValue: environment.baseHref },
    CookieService,
    ModalLocationEntryService,
    ModalResultStyleService,
    LayerSelectionDialogService,
    LabelStyleDialogService,
    ResultsPopupEditorDialogService,
    SaveMapDialogService,
    LoadMapDialogService,
    SaveLayerDialogService,
    LoadLayerDialogService,
    ExportDataDialogService,
    ColorGenDialogService,
    LayerViewsService,
    GeocodeService,
    ResultsService,
    GeomSymsService,
    DynamicComponentService,
    ColorPickerDialogService,
    LayerPickerDialogService,
    MapPickerDialogService,
    AdddAttributeDialogService,
    KmlExportService,
    ShpExportService,
    ProjectionService,
    ExcelIoService,
    ActionHandlerService,
    ButtonGroupService,
    CriteriaService,
    ColorBrewerService,
    SlColorsService,
    PdfExportService,
    PDFOutputPreviewDialogService,
    MediaService,
    ScaleAndLocationDialogService,
    CustomSymbolDialogService,
    SandboxMessengerService,
    ClipboardService,
    ScaleService,
    [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
    [{ provide: DEFAULT_TIMEOUT, useValue: 300000 }]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

declare module '@angular/core' {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}
